import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";

const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_REAL_NAME: (state, realName) => {
    state.realName = realName;
  },
};

const actions = {
  // user login
  async login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo;
    try {
      const response = await login({ username: username.trim(), password: password });
      const { data } = response;
      commit("SET_TOKEN", data.token);
      setToken(data.token);
      // 直接从login响应中获取用户信息，避免getInfo可能的数据不一致问题
      if (data.userInfo) {
        commit("SET_NAME", data.userInfo.username);
        commit("SET_REAL_NAME", data.userInfo.realName);
        // 同步更新localStorage
        localStorage.setItem("userinfo", JSON.stringify(data.userInfo));
      } else {
        // 兼容：如果login没返回userInfo，再调用getInfo
        await dispatch("getInfo");
      }
    } catch (error) {
      throw error;
    }
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          const { data } = response;
          if (!data) {
            return reject("Verification failed, please Login again.");
          }
          const { username, realName } = data;
          commit("SET_REAL_NAME", realName);
          commit("SET_NAME", username);
          // 同步更新localStorage，防止页面缓存显示旧数据
          localStorage.setItem("userinfo", JSON.stringify(data));
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          
          // 清理 localStorage 中的缓存
          localStorage.removeItem("video-play-status");
          localStorage.removeItem("userinfo");
          localStorage.removeItem("capturedPhotos");
          
          // 清理 sessionStorage
          sessionStorage.clear();
          
          // resetRouter()
          commit("RESET_STATE");
          // 重载页面
          window.location.reload();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
